import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { profileService, stockService } from "../services/apiService";
import SlidingMenu from "../components/SlidingMenu";
import TermsCondition from "../components/TermsCondition";

const ProtectedRoute = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [auth, setAuth] = useState(false);
  const [checked, setChecked] = useState(false);
  const [tcAccepted, setTcAccepted] = useState(true); // default true to avoid flash

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setAuth(false);
      setChecked(true);
      return;
    }

    profileService
      .getProfile()
      .then(() => {
        setAuth(true);
        setChecked(true);
        // Check T&C status
        stockService.getBillingStatus()
          .then((data) => {
            setTcAccepted(data?.tcAccepted !== false);
          })
          .catch(() => setTcAccepted(true)); // if API fails, don't block
      })
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("userName");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("userFullName");
        localStorage.removeItem("companyName");
        setAuth(false);
        setChecked(true);
      });
  }, []);

  if (!checked) {
    return null;
  }

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <SlidingMenu mobileOpen={mobileMenuOpen} onCloseMobile={() => setMobileMenuOpen(false)} />
      <div className="flex-1 min-w-0 overflow-hidden h-full relative">
        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="fixed top-3 left-3 z-30 md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-white shadow-md border border-blue-200 text-blue-700"
        >
          <i className="fas fa-bars" />
        </button>
        {children}
      </div>
      {!tcAccepted && (
        <TermsCondition onAccepted={() => setTcAccepted(true)} />
      )}
    </div>
  );
};

export default ProtectedRoute;
